import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ProductShowcase() {
  return <section className="pt-12 md:pt-20 pb-6 md:pb-8 px-4 bg-brand-light" data-id="element-241">
      <div className="max-w-5xl mx-auto text-center" data-id="element-242">
        <div className="inline-flex items-center justify-center gap-2 bg-yellow-100 text-yellow-800 font-bold px-4 py-2 rounded-full mb-6" data-id="element-243">
          <span data-id="element-244">🏆</span> El sistema de capacitación minera N°1 disponible en
          Argentina
        </div>

        <h2 className="text-4xl md:text-6xl font-black text-brand-dark mb-4" data-id="element-245">
          ⛏️ MEGAPACK ESPECIALIZACIONES MINERAS
        </h2>
        <h3 className="text-3xl md:text-4xl font-extrabold text-brand-blue mb-8" data-id="element-246">
          52 cursos profesionales + softwares + manuales + seguridad
        </h3>

        <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-6 md:mb-12" data-id="element-247">
          52 cursos profesionales + softwares originales + manuales técnicos +
          capacitaciones de seguridad. Todo organizado, todo en español, todo
          tuyo para siempre.
        </p>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-6 md:mb-12" data-id="element-248">
          {['🔴 Cursos', '💻 Software', '📚 Biblioteca', '🦺 Seguridad'].map(badge => <div key={badge} className="px-6 py-3 bg-white rounded-xl shadow-md flex items-center justify-center text-xl font-black text-brand-blue border-2 border-brand-blue/10" data-id="element-249">
                {badge}
              </div>)}
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-250">
          <div className="text-left bg-white p-5 md:p-8 rounded-2xl shadow-xl" data-id="element-251">
            <h4 className="text-2xl font-black text-brand-dark mb-4 md:mb-6 border-b pb-4" data-id="element-252">
              4 BLOQUES COMPLETOS
            </h4>
            <ul className="space-y-4" data-id="element-253">
              {['52 Cursos profesionales', 'Softwares incluidos', 'Biblioteca técnica', 'Seguridad minera'].map((item, i) => <li key={i} className="flex items-center gap-3 text-xl font-bold text-gray-800" data-id="element-254">
                  <CheckCircleIcon className="w-8 h-8 text-brand-green flex-shrink-0" data-id="element-255" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div data-id="element-256">
            <a href="https://checkout.guiadigital360.online/cart/44819876446277:1" className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" data-id="element-257">
              <img src="https://cdn.magicpatterns.com/uploads/ov9PjFDDvX7wXavA6ykq5M/ChatGPT_Image_27_mar_2026,_11_41_16_a.m..png" alt="MegaPack Especializaciones Mineras" className="w-full drop-shadow-2xl rounded-xl" data-id="element-258" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}